import type { QueryClient } from "@tanstack/react-query";

import { fetchEmployees } from "../../../api/services";

export type EmployeeValue = {
	id: string;
	name: string;
};

type CreateFetchEmployeesForPickerOptions = {
	excludeCurrentUser?: boolean;
};

export const createFetchEmployeesForPicker = (
	queryClient: QueryClient,
	options: CreateFetchEmployeesForPickerOptions = {}
) => {
	const { excludeCurrentUser = false } = options;
	return async (searchTerm: string): Promise<{ id: string; name: string }[]> => {
		const cacheKey = ["selectEmployeeFilter", searchTerm, { excludeCurrentUser }] as const;
		const cachedData = queryClient.getQueryData<{ id: string; name: string }[]>(cacheKey);
		if (cachedData) {
			return cachedData;
		}

		const data = await fetchEmployees({ searchTerm, excludeCurrentUser });
		const employees =
			data.users?.map((user) => ({
				id: user._id,
				name: user.name,
			})) || [];

		queryClient.setQueryData(cacheKey, employees);

		return employees;
	};
};
